//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum UserPermissionsEnum {
	TasksViewClient = 1000,
	TasksViewAll = 1001,
	TasksViewAllOffice = 1002,
	TasksComplete = 1003,
	TasksReportsView = 1004,
	RetentionViewClient = 2000,
	RetentionViewAll = 2001,
	RetentionViewAllOffice = 2002,
	RententionReportView = 2003,
	RetentionStatusChange = 2004,
	RetentionViewNotes = 2005,
	RetentionAddNote = 2006,
	LeadsViewClient = 3000,
	LeadsViewAll = 3002,
	LeadsViewAllOffice = 3003,
	LeadsViewProspects = 3004,
	LeadsCreate = 3005,
	LeadsEdit = 3006,
	LeadsChangeOwner = 3007,
	LeadsChangeStatus = 3008,
	LeadsChangeOriginatedBy = 3009,
	LeadsOverrideSubscriptionPrices = 3010,
	LeadsDelete = 3011,
	LeadsSendToSmarterLaunch = 3012,
	LeadsViewReports = 3013,
	LeadsChangeAddress = 3014,
	LeadsEditLegacyIds = 3015,
	LeadsCreateDuplicates = 3016,
	LeadsCreateInspections = 3017,
	LeadsAddAppointments = 3018,
	LeadsDeleteAppointments = 3019,
	LeadsSubscriptionSendToFieldRoutes = 3020,
	LeadsSubscriptionEdit = 3021,
	LeadsSubscriptionChangeStatus = 3022,
	LeadsChangeStatusWon = 3023,
	LeadsSendToFieldRoutes = 3024,
	LeadsChangeStatusSoldNotScheduled = 3025,
	LeadsEditCompleteInspection = 3026,
	LeadsChangeAssignedUserOverride = 3027,
	LeadsSubscriptionAddAddonOnly = 3028,
	LeadsUnlinkFromFieldRoutes = 3029,
	LeadsEditUnassigned = 3030,
	CommercialLeadsViewClient = 3100,
	CommercialLeadsViewAll = 3101,
	CommercialLeadsViewAllOffice = 3102,
	CommercialLeadsViewProspects = 3103,
	CommercialLeadsCreate = 3104,
	CommercialLeadsEdit = 3105,
	CommercialLeadsChangeOwner = 3106,
	CommercialLeadsChangeStatus = 3107,
	CommercialLeadsChangeOriginatedBy = 3108,
	CommercialLeadsOverrideSubscriptionPrices = 3109,
	CommercialLeadsDelete = 3110,
	CommercialLeadsChangeAddress = 3111,
	CommercialLeadsEditLegacyIds = 3112,
	CommercialLeadsSubscriptionEdit = 3113,
	CommercialLeadsSubscriptionChangeStatus = 3114,
	CommercialLeadsChangeStatusWon = 3115,
	CommercialLeadsChangeStatusSoldNotScheduled = 3116,
	CommercialLeadsChangeAssignedUserOverride = 3117,
	CommercialLeadsSubscriptionAddAddonOnly = 3118,
	CanvasViewClient = 4000,
	CanvasAddLead = 4001,
	CollectionsViewClient = 5000,
	CollectionsReportView = 5001,
	CollectionsViewAll = 5002,
	CollectionsViewAllOffice = 5003,
	CollectionsClose = 5004,
	UserActivityViewClient = 6000,
	UserActivityViewAll = 6001,
	UserActivityViewAllOffice = 6002,
	NotificationReceiveNewLeadsAlertEmails = 7000,
	NotificationReceiveSubscriptionTemplateAlertEmails = 7001,
	NotificationReceiveD2DSaleAlerts = 7002,
	CallLogsViewClient = 8000,
	CallLogsViewAll = 8001,
	CallLogsViewAllOffice = 8002,
	MapAreaCreator = 9000,
	MapAreaEditor = 9001,
	GlobalMapAreaEditor = 9002,
	MapAreaViewer = 9003,
	MapAreaDelete = 9004,
	DashboardTasksView = 10000,
	DashboardLeadsView = 10100,
	DashboardSalesView = 10200,
	DashboardDoorknockingView = 10300,
	DashboardStaleLeadsView = 10400,
	CustomerDashboardView = 11000,
	CustomerModifier = 11001,
	ReferralViewClient = 11100,
	AdminTagsManager = 12000,
	AdminViewClient = 99000,
	AdminUsersCreate = 99001,
	AdminUsersEdit = 99002,
	AdminUsersViewAll = 99003,
	AdminUsersView = 99100,
	AdminOfficesView = 99200,
	AdminOfficesCreate = 99201,
	AdminOfficesEdit = 99202,
	AdminLeadConfigView = 99300,
	AdminLeadLostStatusView = 99310,
	AdminLeadLostStatusEdit = 99311,
	AdminLeadLostStatusCreate = 99312,
	AdminLeadSourceView = 99320,
	AdminLeadSourceEdit = 99321,
	AdminLeadSourceCreate = 99322,
	AdminLeadWatchListView = 99330,
	AdminLeadWatchListEdit = 99331,
	AdminLeadWatchListCreate = 99332,
	AdminSubscriptionTemplatesView = 99400,
	AdminSubscriptionTemplatesEdit = 99401,
	AdminSubscriptionTemplatesCreate = 99402,
	AdminTrackingNumbersView = 99500,
	AdminTrackingNumbersEdit = 99501,
	AdminTrackingNumbersCreate = 99502,
	AdminPestsView = 99600,
	AdminPestsEdit = 99601,
	AdminPestsCreate = 99602,
	AdminWisetackUserCreate = 99700,
	AdminWisetackUserDelete = 99701,
	AdminJobSpecialtyManage = 99800,
	AdminTeamsView = 99900,
	AdminTeamsEdit = 99901,
	AdminTeamsCreate = 99902,
	AdminTeamsDelete = 99903,
	CollectionsDashboardView = 100000,
	SendContractToCustomer = 100002,
	CanDeleteContracts = 100004,
	DoorknockingMapView = 100101,
	DoorknockingCanKnockOutsideZone = 100102,
	DoorknockingKnocksViewAll = 100103,
	DoorknockingSaleByAddress = 100104,
	DashboardBranchManagerView = 100400,
	SchedulingView = 100500,
	AdminBrandingManagement = 110000,
	CommunicationsViewClient = 120000,
	CommunicationsSendOutboundMessages = 120001
}
